import { trace } from './services/analyticsService'

const consoleError = console.error
console.error = function (message, ...args) {
  if (typeof message === 'string') {
    if (message.includes('validateDOMNesting')) return
    if (message.includes('Element already has context attribute:')) return
    // Suppress React DevTools warning
    if (message.includes('Download the React DevTools')) return
  }
  consoleError.apply(console, [message, ...args])
}

// Also suppress React DevTools warning in console.log
const consoleLog = console.log
console.log = function (message, ...args) {
  if (typeof message === 'string' && message.includes('Download the React DevTools')) {
    return
  }
  consoleLog.apply(console, [message, ...args])
}

document.addEventListener('copy', function (e) {
  const selectedText = window.getSelection()?.toString()
  trace({
    event: 'copy_to_clipboard',
    labels: {
      text: selectedText || 'unknown',
      type: 'copy'
    }
  })
})
